import React from "react"

// MUI
import { Container, Stack, Typography, useTheme } from "@mui/material"

// Components
import SimplifyBorrowingItems from "../../components/simplify-borrowing-items"

// ---------------------------------------------------------------------------------------------------------------------

const SimplifyBorrowing = () => {
  // Use Theme
  const theme = useTheme()

  return (
    <Container sx={{ pb: 2, mt: 10 }}>
      <Stack direction='row' alignItems='center' spacing={1} justifyContent='center'>
        <Typography
          variant='h3'
          fontWeight='bold'
          sx={{ color: theme.palette.mode === "dark" ? "#fff" : "#000000" }}
          textAlign='center'
        >
          به سرعت جت وام بگیرید
        </Typography>
      </Stack>
      <SimplifyBorrowingItems />
    </Container>
  )
}

export default SimplifyBorrowing
